import React from 'react';

const challenges = [
    {
        question: '生成AI、うちでは何に使える？',
        support: '業務での活用場面を整理し、技術面と運用面から実現方法を一緒に検討します。'
    },
    {
        question: 'データ基盤、何を選ぶべき？',
        support: '扱うデータや活用目的を踏まえ、基盤の選定と構成を検討します。'
    },
    {
        question: 'このシステム構成で本当にいい？',
        support: '構成案を技術的な観点から確認し、懸念点や改善案を整理します。'
    },
    {
        question: 'PoCはできた。本番化をどうする？',
        support: '運用や拡張性を見据え、本番化に向けた設計・進め方を検討します。'
    },
    {
        question: 'ベンダー提案、妥当か判断したい',
        support: '提案内容や選択肢を技術的な観点から確認し、判断材料を整理します。'
    }
];

const Challenges = () => (
    <section id="challenges" className="py-20 bg-gray-50 dark:bg-gray-900 transition-colors duration-300 scroll-mt-16">
        <div className="container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
                <h2 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white mb-4">相談できること</h2>
                <p className="text-gray-600 dark:text-gray-300">課題がまだ整理できていない段階から、一緒に考えます。</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {challenges.map(({ question, support }, index) => (
                    <article key={question} className="bg-white dark:bg-gray-800 rounded-xl border border-gray-100 dark:border-gray-700 p-6 shadow-sm">
                        <span className="text-sm font-semibold text-gray-500 dark:text-gray-400">相談 {String(index + 1).padStart(2, '0')}</span>
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white mt-3 mb-3">{question}</h3>
                        <p className="text-sm leading-relaxed text-gray-600 dark:text-gray-300">{support}</p>
                    </article>
                ))}
            </div>
            <div className="text-center mt-10">
                <a href="#services" className="font-semibold text-gray-900 dark:text-white underline underline-offset-4 hover:opacity-70 transition-opacity">
                    専門性・支援領域を見る
                </a>
            </div>
        </div>
    </section>
);

export default Challenges;
